import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageContent from "@my-dld/components/PageContent";
import { VaultContext } from "../VaultContext";
import { FileItem, FolderItem, getItemDate, readableFileSize, TokenAccess } from "../api/entities";
import { formatAppDate } from "../../utils/Utils";
import { Redirect } from "react-router";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import VerifyAccess from "./VerifyAccess";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { requestAccess } from "../api/api";
import cfg from "../api/config";
import { exToMessage } from "@eres/ssoapi/api";

interface Props extends RoutedViewProps {

}

interface State {
	selectedFiles: string[];
	showVerify: boolean;
	accessRequestId?: string;
}

export default class View extends Component<Props, State> {

	static contextType = VaultContext;
	context!: React.ContextType<typeof VaultContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			showVerify: false,
			selectedFiles: [],
		};
	}

	componentDidMount() {
		this.configDataTable();
	}

	render() {
		const { selectedFiles, showVerify, accessRequestId } = this.state;
		const { refId, searchResult } = this.context;
		if ( !searchResult ) {
			return <Redirect to={ "search" }/>;
		}
		const result = searchResult!;
		return <PageContent title={ Strings.dld_vault } hideQLinks={ true }>
			<PageTitle title={ Strings.dld_vault } paths={ [ DashboardBCItem ] }/>

			<div className="row">
				<FolderInfo data={ result }/>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 vault-table">
					<div className="table-box mt-3 mb-3">
						<div className="table-title">{ Strings.document_list }</div>
						<table
							id={ `vaultDocumentDownload-${ refId }` }
							className="table table-borderless table-condensed table-striped table-responsive-sm dataTable no-footer">
							<thead>
							<tr>
								<th className="vault-checkbox">
									<input type="checkbox" id="chk-all" data-vault-id={ "all" }/>
									{ Strings.file_name }
								</th>
								<th>{ Strings.date }</th>
								<th>{ Strings.size }</th>
							</tr>
							</thead>
							<tbody>
							{ searchResult.files?.map( ( value, index ) => {
								return <FileTableItem data={ value } key={ value.name + "-" + index }/>;
							} ) }
							</tbody>
						</table>
					</div>
					{ showVerify &&
						<VerifyAccess
							requestId={ accessRequestId! }
							onCancel={ this.onVerifyCancel } onConfirmed={ this.onConfirmed }/>
					}
					<button
						disabled={ selectedFiles.length === 0 }
						type="button" className="btn btn_1 btn_style1" data-bs-toggle="modal"
						onClick={ this.onContinue }
						data-bs-target="#OTPVerification">{ Strings.proceed }
					</button>
					<button
						className="btn btn-grey btn_style1 ms-2 me-2"
						onClick={ this.props.history.goBack }> { Strings.back }</button>
				</div>
			</div>
		</PageContent>;
	}

	onConfirmed = ( tokens: TokenAccess[] ) => {
		this.setState( {
			showVerify: false,
		}, () => {
			// showLoading();
			this.download( tokens ).then( () => {
				console.log( "Done" );
				//  hideLoading();
			} ).catch( ( e ) => {
				console.log( "error", e );
			} );
		} );

	};

	download = async ( tokens: TokenAccess[] ) => {
		const { searchResult } = this.context;
		for ( const token of tokens ) {
			const file = searchResult?.files?.find( x => x._id === token._id );
			if ( file ) {
				await download( token, file );
			}
		}
	};
	onVerifyCancel = () => {
		this.setState( {
			showVerify: false,
		} );
	};
	onAllChanged = ( selected: boolean ) => {
		if ( selected ) {
			const { searchResult } = this.context;
			this.setState( { selectedFiles: searchResult?.files?.map( x => x._id ) || [] } );
		} else this.setState( { selectedFiles: [] } );
	};

	onSingleChanged = ( id: string, selected: boolean ) => {
		const { selectedFiles } = this.state;
		if ( selected ) {
			this.setState( {
				selectedFiles: [ ...selectedFiles, id ]
			} );
		} else {
			this.setState( {
				selectedFiles: selectedFiles.filter( x => x !== id )
			} );
		}
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( this.state.selectedFiles !== prevState.selectedFiles ) {
			const total = this.context.searchResult?.files?.length || 0;
			if ( this.state.selectedFiles.length !== total ) {
				window.$( `#chk-all` ).prop( "checked", false );
			} else {
				window.$( `#chk-all` ).prop( "checked", true );
			}
		}
	}

	onContinue = () => {
		const files = this.state.selectedFiles;
		if ( files && files.length > 0 ) {
			showLoading();
			this.setState( {
				accessRequestId: undefined,
			} );
			requestAccess( files ).then( x => {
				hideLoading();
				this.setState( {
					accessRequestId: x.data.refNumber,
				}, () => {
					this.setState( {
						showVerify: true,
					} );
				} );
			} ).catch( e => {
				hideLoading();
				exToMessage( e ).then( message => {
					showErrorMessage( message.error );
				} );
			} );
		}

	};
	private configDataTable = () => {
		const { refId } = this.context;
		const self = this;
		try {
			window.$( `#vaultDocumentDownload-${ refId }` ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true,
				"columnDefs": [ {
					"targets": 0,
					"orderable": false
				} ]
			} );
			window.$( `#vaultDocumentDownload-${ refId }` ).on( "click", "input", ( e: any ) => {
				const target = e.target;
				const id = target.dataset[ "vaultId" ];
				const checked = target.checked;
				if ( id ) {
					if ( id === "all" ) {
						window.$( `#vaultDocumentDownload-${ refId } tbody :checkbox` ).prop( "checked", checked );
						self.onAllChanged( checked );
					} else {
						self.onSingleChanged( id, checked );
					}
					e.stopImmediatePropagation();
				}
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function FileTableItem( props: { data: FileItem } ) {
	const { data } = props;
	const id = data._id;
	return <tr>
		<td data-label={ Strings.file_name } className="vault-checkbox">
			<input type="checkbox" id={ `chk-${ id }` } data-vault-id={ id }/>
			<label htmlFor={ `chk-${ id }` } className="mb-0">{ data.name }</label>
		</td>
		<td data-label={ Strings.date }>{ formatAppDate( getItemDate( data ) ) }</td>
		<td data-label={ Strings.size }>{ readableFileSize( data.size ) }</td>
	</tr>;
}

function FolderInfo( props: { data: FolderItem } ) {
	const { data } = props;
	return <div className="col-md-12">
		<div className="vault-card">
			<div>
				<i className="icon-vault-folder"/>
				<div className="vault-doc-detail">
					<span>{ data.name }</span>
					<span>{ formatAppDate( getItemDate( data ) ) } - { Strings.ref } : { data.refNumber }</span>
				</div>
			</div>
		</div>
	</div>;
}

function download( token: TokenAccess, file: FileItem ): Promise<any> {
	const url = `${ cfg.vaultApi().endPoint() }share/files?dlToken=${ token.dlToken }`;
	return fetch( url, {
		method: "GET"
	} )
	.then( ( response ) => response.blob() )
	.then( ( blob ) => {
		const url = window.URL.createObjectURL(
			new Blob( [ blob ] ),
		);
		const link = document.createElement( "a" );
		link.href = url;
		link.setAttribute(
			`download`,
			`${ file.name }`,
		);
		document.body.appendChild( link );
		link.click();
		link.parentNode?.removeChild( link );
	} );
}
